import { externalResourcesApi } from "@tsp-domains/external-resources/api";
import { supplierWorkTypesApi } from "@tsp-domains/supplier-work-types/api";

import { externalApi } from "./features/external";
import { payoutApi } from "./features/payout";
import { userApi } from "./features/user";

export default {
  ...userApi,
  ...payoutApi,
  ...externalApi,
  ...supplierWorkTypesApi,
  ...externalResourcesApi,
};
